import React from 'react'
import { allSkillIds } from '../nodeUpdates/skillsListNoteNode'
import { Standard } from 'shared/types'
import { addSkillForId, useDeleteLeaf } from '../TreeActions'
import { Box } from '@mui/material'
import { StandardRetriever } from 'components/standards/StandardRetriever'
import { INode } from 'shared/types/tree'

// This component renders the current skills list, the skills included
// and provides the ability to edit those skills lists
export function SkillsView({
  node,
  onUpdate,
}: {
  node: INode
  onUpdate?: () => void
}) {
  const deleteLeaf = useDeleteLeaf()

  const skillsIds = allSkillIds(node)
  const onSelect = async ({ standardId }: Standard) => {
    await addSkillForId(node, standardId)
    onUpdate?.()
  }
  const onDelete = async ({ standardId }: Standard) => {
    const leaf = node.leaves?.find(
      ({ body: { skillID } }) => skillID === standardId,
    )
    if (!leaf) return
    await deleteLeaf({
      leafId: leaf.id,
      treeId: leaf.tree_id!,
      versionId: leaf.version!,
    })
    onUpdate?.()
  }
  return (
    <Box>
      <Box>
        <strong>Standards</strong>
      </Box>
      <StandardRetriever
        currentStandardIds={skillsIds}
        onStandardSelect={onSelect}
        onStandardDelete={onDelete}
      />
    </Box>
  )
}
